import { SStorage, SThread } from "servisofts-component2";
import SSocket from "servisofts-socket";
// import CryptoJS from 'crypto-js';
import MDLAbstract from "../MDLAbstract";
import { EventListener, Expedicion } from "./types";
import HTTP from "../../HTTP";
import Config from "../../Config";
import MDL from "..";


export default class sigestran extends MDLAbstract<EventListener> {
    async componentDidMount() {

    }

    expediciones: Expedicion[] = [];

    getExpediciones = async () => {
        const user = MDL.usuario.session;
        if (!user) {
            throw "No hay usuario logueado";
        }
        if (!user.token) {
            console.log("El usuario no tiene token", user);
            throw "El usuario no tiene token";
        }
        const response: any = await HTTP.GET({
            url: Config.apis.sigestran + "/chofer/expediciones/" + user.lChofer_id + "/" + user.plate,
            // token: MDL.usuario.session?.token,
            // body: arrPuntos
        });

        const arrID: any = []
        response.map((expedicion: any) => {
            expedicion.origen = JSON.parse(expedicion.origen);
            expedicion.destinos = JSON.parse(expedicion.destinos);
            expedicion.cliente = JSON.parse(expedicion.cliente);
            // arrID[expedicion.lExpedicionReal_id] = true;
            arrID.push(expedicion.lExpedicionReal_id);

        })
        this.expediciones = response;
        const situacion = await this.getSituacionByExpedicion(arrID);
        if (situacion) {
            situacion.map((item: any) => {
                const expedicion = this.expediciones.find(exp => exp.lExpedicionReal_id === item.id_expedicion);
                if (expedicion) {
                    expedicion.situaciondb = item;
                }
            })
        }

        this.dispatchEvent({
            type: "changeExpediciones",
            expediciones: this.expediciones,
        });
        return response;
    }

    getSituacionByExpedicion = async (id_expedicion_arr: any[]) => {
        try {
            console.log("getSituacionByExpedicion", id_expedicion_arr);

            const response = await HTTP.GET({
                url: Config.apis.usuario + "/database/rowsin/situacion/id_expedicion/" + JSON.stringify(id_expedicion_arr).replace("[", "").replace("]", ""),
                token: MDL.usuario.session?.token,
            });
            if (!response || response.length <= 0) return null
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }
}